import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { ReactNode } from 'react'

interface ITitleSectionAccordion {
  expanded?: boolean
  onChange?: (event: React.SyntheticEvent, expanded: boolean) => void
  allwaysShow?: boolean
  title: string
  children?: ReactNode
  CustomSummary?: ReactNode
}

export default function TitleSectionAccordion({
  expanded,
  onChange,
  allwaysShow,
  title,
  children,
  CustomSummary,
}: ITitleSectionAccordion) {
  return (
    <Accordion
      className="flex flex-col bg-none shadow-none before:invisible"
      square
      disableGutters
      expanded={allwaysShow || expanded}
      onChange={onChange}
    >
      {CustomSummary || (
        <AccordionSummary
          className={`${
            allwaysShow ? 'cursor-default' : undefined
          } [&>.MuiAccordionSummary-content]:border-b-solid px-0 [&>.MuiAccordionSummary-content]:border-b [&>.MuiAccordionSummary-content]:border-[#BDBDBD]`}
          expandIcon={
            allwaysShow ? undefined : <ExpandMore className="text-light-blue" />
          }
        >
          <h4 className="flex w-full justify-between py-2">{title}</h4>
          {!allwaysShow && (
            <span className="min-w-fit self-center text-sm font-[var(--font-poppins)] uppercase text-light-blue">
              Ver mais
            </span>
          )}
        </AccordionSummary>
      )}

      <AccordionDetails className="gap-8 px-0">{children}</AccordionDetails>
    </Accordion>
  )
}
